export default store => {
  return {
    async getPersonalInfo(params) {
      return await store.dispatch(`personal/info`, {
        params
      });
    },
    async getPersonalAlbums(params) {
      return await store.dispatch(`personal/albums`, {
        params
      });
    },
    async getPersonalSingles(params) {
      return await store.dispatch(`personal/singles`, {
        params
      });
    }
  };
};
